import classNames from "classnames";
import { useUser } from "../../functional-components/UserContext";
import {
  useSpecsGroupTranslation,
  useSpecsTranslation,
  useUnitTranslation
} from "../../hooks/TranslationHooks";
import InfoIconWithPopup from "../InfoIconWithPopup";
import "./style.scss";

const ProductSpecification = ({ specsGrouped }) => {
  const { admin } = useUser();
  const ts = useSpecsTranslation();
  const tu = useUnitTranslation();
  const tg = useSpecsGroupTranslation();

  //console.log("specsGrouped", specsGrouped);

  if (!specsGrouped) {
    return null;
  }
  const items = Object.entries(specsGrouped)
    .filter(
      ([_group, specs]) => specs?.filter(sp => admin || !sp.hidden).length > 0
    )
    .map(([group, specs]) => (
      <div key={group} className="specification-group">
        <h4>{tg(group)}</h4>
        {specs
          .filter(sp => admin || !sp.hidden)
          .map(({ field, value, unit, note, hidden }, idx) => {
            const fld = field.split("_")[0];
            return (
              <div key={idx} className={classNames({ "spec-hidden": hidden })}>
                <strong>{ts(fld) + ":"}</strong>
                {" " + ts(fld, value)} {unit && tu(unit)}
                {note ? <span className="spec-note">({note})</span> : ""}
                <InfoIconWithPopup field={field} />
              </div>
            );
          })}
      </div>
    ));

  return <div className={"mb-3"}>{items}</div>;
};

export default ProductSpecification;
